import { SUPPLIER_ROLES, PERMISSIONS } from 'constants/all';

import type { RootState } from 'store/configureStore';
import { selectors as sessionSelectors } from 'store/session';

import { featureFlagKeys } from './drawers/featureFlagDrawer/const/featureFlagKeys';
import { FeatureFlag } from './drawers/featureFlagDrawer/const/featureFlags';

export const isAuthenticated = (state: RootState) => {
  return sessionSelectors.getIsLoggedIn(state);
};

export const withFeatureFlag =
  (featureFlagKey: FeatureFlag) => (state: RootState) => {
    return sessionSelectors.getFeatureFlagValue(state, featureFlagKey);
  };

export const isQuotingToolAvailable = (state: RootState) => {
  return sessionSelectors.getFeatureFlagValue(
    state,
    featureFlagKeys.isQuotingToolAvailable,
  );
};

export const isSupplier = (state: RootState) => {
  return sessionSelectors.isSupplier(state);
};

export const hasAccessToContacts = (state: RootState) => {
  return (
    sessionSelectors.getGroupMemberSupplierRoles(state)[
      SUPPLIER_ROLES.CUSTOMERS
    ] !== PERMISSIONS.NO_ACCESS
  );
};

export const hasProcessPermission = (state: RootState) => {
  return (
    sessionSelectors.getGroupMemberSupplierRoles(state)[
      SUPPLIER_ROLES.PROCESSES
    ] !== PERMISSIONS.NO_ACCESS
  );
};

export const hasQuotingPermission = (state: RootState) => {
  return (
    sessionSelectors.getGroupMemberSupplierRoles(state)[
      SUPPLIER_ROLES.QUOTES
    ] !== PERMISSIONS.NO_ACCESS
  );
};
